<template>
  <div class="container page">
    <van-nav-bar :title="vod_name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="right">
      <van-pull-refresh class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
        <van-grid :column-num="2" :gutter="10">
          <van-grid-item @click="profile(v.id)" v-for="(v, k) in datalist" :key="k">
            <van-image class="game_item_img" :src="mediaUrl(v.img_url)">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
            <span class="rig-name">{{ v.xuanfei_name }}</span>
          </van-grid-item>
        </van-grid>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vod_name: '',
      isLoading: false,
      datalist: []
    }
  },
  methods: {
    mediaUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      const base = process.env.NODE_ENV === 'development' ? '' : 'https://d2h0m7gk9kbvfa.cloudfront.net'
      return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`
    },
    back() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ path: '/Choose' })
      }
    },
    onRefresh() {
      this.getxuanfeilist()
      setTimeout(() => {
        this.$toast(this.$t('reservation.refresh'))
        this.isLoading = false
      }, 500)
    },
    profile(id) {
      this.$router.push({
        path: '/Profile',
        query: {
          id,
          name: this.vod_name,
          adsid: this.$route.query.id
        }
      })
    },
    getxuanfeilist() {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: this.$route.query.id }
      }).then(res => {
        const payload = res.data || {}
        this.datalist = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : [])
      })
    }
  },
  created() {
    this.vod_name = this.$route.query.name || ''
    this.getxuanfeilist()
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';
.right {
  flex: 1;
  overflow-y: auto;
  background: #f2f2f5;
  min-height: 0;
}
.list-wrapper {
  padding: 10px;
  min-height: 100%;
}
::v-deep .van-grid-item__content--center {
  border-radius: 15px;
  padding: 0;
  height: auto;
  background: #fff;
}
.game_item_img {
  width: 100%;
}
::v-deep .van-image__img {
  border-radius: 10px 10px 0 0;
  padding: 10px 10px 0;
}
.rig-name {
  width: 100%;
  line-height: 2.5;
  margin-top: 0;
  background-color: #fff;
  border-radius: 0 0 15px 15px;
  font-size: 14px;
  padding: 0 10px 8px;
  color: #333;
  text-align: center;
}
</style>
